export default __webpack_public_path__ + "static/media/brokenVase@2x.1bf0e5cc.jpg";